import { render, staticRenderFns } from "./ArquivoRecebido.vue?vue&type=template&id=c8c5b3ee&scoped=true"
import script from "./ArquivoRecebido.vue?vue&type=script&lang=js"
export * from "./ArquivoRecebido.vue?vue&type=script&lang=js"
import style0 from "./ArquivoRecebido.vue?vue&type=style&index=0&id=c8c5b3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c5b3ee",
  null
  
)

export default component.exports